import { useState } from 'react';
import { ViewContainer } from '@web/components/ui/view-container'; // <-- New container

import { ProductDetailsView } from './details/products-details-view';
import { ProductsTable } from './list/products-table';

import { Route } from '..';
import { Filter } from '@web/components/ui/view-filters';
import { trpc } from '@web/lib/trpc';

export function ProductInterface() {
  const navigate = Route.useNavigate();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [selectedProductId, setSelectedProductId] = useState<string | null>(
    null,
  );

  const { displayName } = Route.useSearch();

  const { data: productsData, refetch: refetchProductsData } =
    trpc.product.listAllWithPagination.useQuery({
      page,
      pageSize,
      displayName,
    });

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPage(1);
  };

  const filters = [
    {
      key: 'displayName',
      label: 'Name',
      type: 'string',
      value: displayName,
      isMainFilter: true,
    },
  ] as const satisfies Filter[];

  const onFilterChange = (
    newSearch: Record<string, string | number | boolean | object | undefined>,
  ) => {
    void navigate({
      search: (current) => ({ ...current, ...newSearch }),
    });
  };

  // Main content: products exist
  return (
    <div>
      <ViewContainer
        title="Products"
        filters={filters}
        onFilterChange={onFilterChange}
      >
        {/* Your table or any other content goes here */}
        <ProductsTable
          products={productsData?.products}
          onDetails={({ id }) => {
            setSelectedProductId(id);
          }}
          pagination={{
            currentPage: page,
            totalPages: productsData?.totalPages ?? 1,
            totalItems: productsData?.total ?? 0,
            pageSize,
            onPageChange: handlePageChange,
            onPageSizeChange: handlePageSizeChange,
          }}
        />
      </ViewContainer>

      {/* Dialog for creating/editing products */}
      {selectedProductId !== null && (
        <ProductDetailsView
          productId={selectedProductId}
          onClose={() => {
            setSelectedProductId(null);

            void refetchProductsData();
          }}
        />
      )}
    </div>
  );
}
